export const RECOMMENDED_EDUCATOR = [
  { value: 1, label: "Clinical Educator" },
  { value: 2, label: "Peer Educator" },
  { value: 3, label: "Both Educator" },
];
